import React from 'react';
import styles from './Degrees.module.scss';
import SlideOne from './degreesCarousel/SlideOne/SlideOne';
import { useMediaQuery } from 'react-responsive';

const bachelorsImage = '/images/homepage/degrees/Bachelors.jpg';
const bachelorsImageMobile = '/images/homepage/degrees/bachelor-m3.png';

const Degrees = () => {
  const isMobile = useMediaQuery({ maxWidth: 800 });

  return (
    <div className={styles['degrees-contaner']}>
      <div className={styles.hue}></div>
      <img
        src={isMobile ? bachelorsImageMobile : bachelorsImage}
        alt=""
        className={styles.bachelorsImage}
      />

      <SlideOne />
    </div>
  );
};

export default Degrees;
